import React from 'react';
import { Card, Flex, Typography, Grid, Progress } from 'antd';
import { styled } from 'styled-components';
import { ArrowRightOutlined } from '@ant-design/icons';
import { FetchMerchantOnboardingsV2Response } from '@shared/types';
import { t } from '../../../../utils/i18n';

const { useBreakpoint } = Grid;

const StyledSetupProgressCard = styled(Card)`
  margin: 2rem;
  min-width: 20rem;
  cursor: pointer;
  background-color: #f5f5f5;
  transition: background-color 0.4s ease;

  &:hover {
    background-color: #ebebeb;
  }

  .ant-v5-card-body {
    padding: 1.5rem;
  }
`;

const StyledSlimSetupProgressCard = styled(Card)`
  margin: 1.75rem;
  cursor: pointer;
  background-color: #f5f5f5;
  transition: background-color 0.4s ease;

  .ant-v5-card-body {
    padding: 0.5rem;
    display: flex;
    justify-content: center;
  }
`;

const StyledRightIcon = styled(ArrowRightOutlined)`
  font-size: 1.25rem;
  color: rgba(0, 0, 0, 0.45) !important;
`;

type SetupProgressCardProps = {
  sideMenuCollapsed: boolean;
  onboardingStepsData: FetchMerchantOnboardingsV2Response | undefined;
  onCardClick: () => void;
};

export function SetupProgressCard({
  sideMenuCollapsed,
  onboardingStepsData,
  onCardClick,
}: SetupProgressCardProps) {
  const screens = useBreakpoint();

  const totalTasks = onboardingStepsData?.steps?.length ?? 0;
  const percentageCompleted =
    onboardingStepsData?.overall_progress_percentage ?? 0;
  const completedTasks =
    totalTasks > 0 ? Math.round((percentageCompleted / 100) * totalTasks) : 0;

  if (!screens.md || sideMenuCollapsed) {
    return (
      <StyledSlimSetupProgressCard onClick={onCardClick}>
        <Flex gap={10} align="center" justify="flex-start">
          <Progress
            type="circle"
            percent={percentageCompleted}
            strokeColor="#00c2d1"
            size={22}
            format={() => null}
          />
        </Flex>
      </StyledSlimSetupProgressCard>
    );
  }

  return (
    <StyledSetupProgressCard onClick={onCardClick}>
      <Flex gap={10} align="center" justify="flex-start">
        <Progress
          type="circle"
          percent={percentageCompleted}
          strokeColor="#00c2d1"
          size={25}
          format={() => null}
        />
        <Typography.Text strong style={{ fontSize: 16 }}>
          {t('side-menu-cards.setup-progress.title')}
        </Typography.Text>
      </Flex>
      <Flex
        gap={10}
        align="flex-end"
        justify="space-around"
        style={{ marginTop: 8 }}
      >
        <Typography.Text type="secondary" style={{ fontSize: 12 }}>
          {t('side-menu-cards.setup-progress.description', {
            completed_tasks: completedTasks,
            total_tasks: totalTasks,
          })}
        </Typography.Text>
        <StyledRightIcon />
      </Flex>
    </StyledSetupProgressCard>
  );
}
